import React from 'react';
import { ScoreTotalCell } from 'components/scores';
import { viewTypes } from '../enums';

const LeaderboardCellToPar = (
    {
        player,
        playerSD,
        view,
        isPlayOff
    }
) => {
    const renderInfo = () => {
        let playOffText = '';

        if (playerSD.suddenDeathStatus) {
            playOffText = 'Hole-by-hole';
        } else if (playerSD.playOffStatus) {
            playOffText = 'PlayOff';
        }

        return (
            <div className="leaderboard__cell-playoff">
                <div className="leaderboard__cell-playoff-par-text">{playOffText}</div>
                <ScoreTotalCell
                    childCss='leaderboard__score-cell-playoff-par'
                    par={player.playOffToPar}
                />
            </div>
        );
    };

    return (
        <div className="leaderboard__cell leaderboard__cell--par">
            <ScoreTotalCell childCss='leaderboard__score-cell-par' par={player.toPar} />
            {
                isPlayOff &&
                view !== viewTypes.HOLE_BY_HOLE &&
                renderInfo()
            }
        </div>
    );
};

export default LeaderboardCellToPar;
